import script from "./InputUserInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InputUserInfoModal.vue?vue&type=script&setup=true&lang=js"

export default script